<template>
  <div class="EditionsSwiper">

    <div class="EditionsSwiper_prev" slot="button-prev"><img src="../../public/static/images/arrow-right.svg" /></div>
    <div class="EditionsSwiper_next" slot="button-next"><img src="../../public/static/images/arrow-left.svg" /></div>

    <div class="EditionsSwiper_wrapper" :style="{ overflow: totalyVisible ? 'visible' : 'hidden' }">
      <swiper :options="swiperOption" ref="mySwiper" class="EditionsSwiper_swiper" v-show="!totalyVisible">
        <swiper-slide class="EditionsSwiper_slide" v-for="(slide, index) in data" :key="index">
          <Edition :data="slide" />
        </swiper-slide>
      </swiper>
      <div class="EditionsSwiper_swiper EditionsSwiper_swiper_base" v-show="totalyVisible">
        <div class="EditionsSwiper_slide" v-for="(slide, index) in data" :key="index">
          <Edition :data="slide" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Edition from "@/components/Edition"

  export default {
    name: "EditionsSwiper",
    props: [ 'data' ],
    components: { Edition },
    data() {
      return {
        totalyVisible: false,
        swiperOption: {
          slidesPerView: 3,
          grabCursor: true,
          spaceBetween: 20,
          navigation: {
            nextEl: '.EditionsSwiper_next',
            prevEl: '.EditionsSwiper_prev'
          },
          breakpoints: {
            1320: {
              slidesPerView: 'auto',
              centeredSlides: true
            },
            960: {
              spaceBetween: 5,
              slidesPerView: 'auto',
              centeredSlides: true
            }
          }
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    methods: {
      onResize()
      {
        if(this.data.length <= 3 && window.innerWidth > 1320)
        {
          this.$el.querySelector('.EditionsSwiper_next').style.display = "none"
          this.$el.querySelector('.EditionsSwiper_prev').style.display = "none"

          this.totalyVisible = true
        }else{
          this.$el.querySelector('.EditionsSwiper_next').style.display = null
          this.$el.querySelector('.EditionsSwiper_prev').style.display = null

          this.totalyVisible = false
        }


        this.$nextTick( () => {
          if(this.swiper && window.innerWidth <= 1320 && window.innerWidth > 960)
            this.swiper.slideTo(1, 0, false)
        })
      }
    },
    beforeDestroy()
    {
      window.removeEventListener('resize', this.onResize)
    },
    mounted()
    {
      this.onResize()
      window.addEventListener('resize', this.onResize)
    }
  }
</script>

<style lang="stylus">
.EditionsSwiper

  position relative
  width 100%
  max-width 1195px
  margin auto
  padding 0px 60px

  @media screen and (max-width: 1320px)

    padding 0px 0px
    max-width unset

  &_swiper_base

    display flex
    flex-direction row
    align-items stretch
    justify-content center
    overflow visible
    margin 30px auto

    .EditionsSwiper_slide

      margin 0px 10px

  &_wrapper

    width 100%
    overflow hidden

    @media screen and (max-width: 1320px)

      overflow visible

  &_next, &_prev

    position absolute
    top 50%
    transform translateY(-50%)
    transition opacity 0.4s $ease, transform 0.4s $ease
    cursor pointer
    width 40px
    height 40px
    z-index 5

    @media screen and (max-width: 1320px)

      display none

    img

      width 100%

    &:hover

      opacity 0.5
      transform translateY(-50%) scale(1.1)

  &_next

    right 0px

  &_prev

    left 0px

  &_swiper

    @media $small

      width: calc(100vw + 25px);
      left: -25px;
  
  .swiper-container

    padding 30px 0px
    overflow visible

  .swiper-wrapper

    align-items stretch  

  &_slide

    position relative
    width 100%
    height auto!important
    min-height 255px
    max-width 385px

    @media $small

      max-width 325px
      width 75%!important

.ie

  .EditionsSwiper

    &_slide, &_wrapper

      transform translateZ(1px)
      backface-visibility hidden
</style>